import { Container, Row } from 'reactstrap';

const ErrorPage = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="error-page">
      <Container fluid>
        <Row>
          {/* NavBar */}
        </Row>

        <div className="error-page-wrapper">
          <div className="error-page-card">
            <div className="error-page-body">
              <img
                alt="Illustration of a female doctor in blue scrubs standing beside a hospital bed"
                className="error-page-image"
                src="https://storage.googleapis.com/a1aa/image/7dc0da43-42c4-4406-c197-4cffab044c42.jpg"
              />

              <h2 className="error-page-title">
                Oops! It seems like something went wrong.
              </h2>

              <p className="error-page-text">
                We couldn't find the page you're looking for.
                <br />
                We'll work on improving this.
              </p>

              <div className="error-page-actions">
                <button
                  className="error-page-button"
                  onClick={handleRefresh}
                >
                  Refresh Page
                </button>

                <button
                  className="error-page-button"
                  onClick={handleGoHome}
                >
                  Back to home
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ErrorPage;
